import angular from "angular";
import template from "./admin-edit-student.html";
import AdminStudentEditController from "./admin-edit-student.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.students.view.edit", {
    url: "/edit",
    controller: AdminStudentEditController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.staff,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.students.edit", [])
  .config(config)
  .controller("AdminStudentEditController", AdminStudentEditController);
